import memoize from 'lru-memoize';
import {linuxUserRules, createValidator, required, maxLength, email, noSpecialChars, noSpaces, minLength} from 'utils/validation';

const createClientValidation = createValidator({
  name: [required],
  
});
export default memoize(10)(createClientValidation);
